import { render, staticRenderFns } from "./DownloadByOs.vue?vue&type=template&id=afef87b0&scoped=true"
import script from "./DownloadByOs.vue?vue&type=script&lang=js"
export * from "./DownloadByOs.vue?vue&type=script&lang=js"
import style0 from "./DownloadByOs.vue?vue&type=style&index=0&id=afef87b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afef87b0",
  null
  
)

export default component.exports